export const isTimeRangeFlexible = (obj: {
  flexibility: { __typename: "NotFlexible" | string } | null;
}) => !!(obj.flexibility && obj.flexibility.__typename !== "NotFlexible");

export default isTimeRangeFlexible;
